module.exports = __webpack_public_path__ + "img/yanchengAppImage.65701884.png";